import React from "react";
import { Sparkles } from "lucide-react";

/**
 * Selo discreto para notícias geradas pelo Guia News AI.
 * Position absolute — coloque-o dentro de um wrapper `relative`.
 */
export default function GuiaNewsAIBadge({ className = "" }) {
  return (
    <span
      data-testid="guia-news-ai-badge"
      title="Notícia editorial do Guia News AI"
      className={`inline-flex items-center gap-1 rounded-full bg-primary/95 text-primary-foreground text-[10px] font-bold px-2 py-1 shadow-md backdrop-blur-md ${className}`}
    >
      <Sparkles className="w-3 h-3" />
      Guia News AI
    </span>
  );
}
